export default __webpack_public_path__ + "newsletter-content-areas.png";